import styled from 'foundations-theming/utils';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
export default styled(Clickable).withConfig({
  displayName: "EditorFieldOptionBase",
  componentId: "sc-19gkayi-0"
})(["&&&{display:block;width:100%;margin-left:0;padding:", ";&:hover,&:active,&:focus{background-color:", ";}}"], ({
  theme
}) => `${theme.space[200]} 0 ${theme.space[200]} ${theme.space[500]}`, ({
  theme
}) => theme.color['fill-info-subtle']);